import * as Api from "./api";

const REGISTER_B2C_API_URL = "/register/private";
const REGISTER_BUSINESS_API_URL = "/register/business/v2";
const GET_PROFILE_DATA = "/register/business/profile/get";
const VERIFY_PROFILE_API_URL = "/register/business/profile/complete";

const POSTCODE_LOOKUP_API_URL = "/register/postcodelookup";
const CHECK_USERNAME_API_URL = "/register/usernameexists";

const COMPANY_SEARCH_API_URL = "/register/business/companySearch";
const COMPANY_SEARCH_DETAILS_API_URL = "/register/business/companyDetails";
const COMPANY_SEARCH_SUBUNITS_API_URL = "/register/business/companySubUnits";

export function registerUser(data) {
	return Api.postToApi(REGISTER_B2C_API_URL, data);
}

export function registerBusiness(data) {
	return Api.postToApi(REGISTER_BUSINESS_API_URL, data);
}

export function validatePostcodeLookup(data) {
	return Api.postToApi(POSTCODE_LOOKUP_API_URL, {
		postalCode: data.postcode,
		countryCode: data.countryCode,
	});
}

export function checkIfUsernameExists(data) {
	return Api.getFromApi(
		`${CHECK_USERNAME_API_URL}?username=${encodeURIComponent(
			(data.username || "").trim(),
		)}`,
	);
}

export function getProfileData(returnUrl) {
	return Api.getFromApi(
		`${GET_PROFILE_DATA}?returnUrl=${encodeURIComponent(returnUrl)}`,
	);
}

export function searchCompanyData(data) {
	return Api.postToApi(COMPANY_SEARCH_API_URL, {
		country: data.country,
		query: data.query,
		companyType: data.companyType,
	});
}

export function searchCompanyDetails(data) {
	return Api.getFromApi(
		`${COMPANY_SEARCH_DETAILS_API_URL}?lookupId=${data.lookupId}`,
	);
}

export function searchCompanySubUnits(data) {
	return Api.getFromApi(
		`${COMPANY_SEARCH_SUBUNITS_API_URL}?canonicalId=${data.canonicalId}&q=${data.query}`,
	);
}

export function verifyProfile(data) {
	return Api.postToApi(VERIFY_PROFILE_API_URL, data);
}
